/**
 * Feature Flags Configuration
 * Single source of truth for all feature flags
 */

interface FeatureFlags {
    /** Enable using pre-calculated gold table for spark chart data */
    sparkChartBundle: boolean;
    /** Enable Market-wide Leaderboard spark type filter option */
    marketWideLeaderboard: boolean;
    /** Enable editing active/upcoming Sparks (vendor + retailer flows) */
    editSparks: boolean;
    /** Enable the commission rules experience in the spark wizard */
    commissionRules: boolean;
}

const parseFeatureFlags = (): FeatureFlags => {
    return {
        sparkChartBundle: import.meta.env.REACT_APP_SPARK_CHART_BUNDLE === 'true',
        marketWideLeaderboard: import.meta.env.REACT_APP_MARKET_WIDE_LEADERBOARD === 'true',
        editSparks: import.meta.env.REACT_APP_EDIT_SPARKS === 'true',
        commissionRules: import.meta.env.REACT_APP_COMMISSION_RULES === 'true',
    };
};

export const featureFlags = parseFeatureFlags();

export const isSparkChartBundleEnabled = (): boolean => featureFlags.sparkChartBundle;
export const isMarketWideLeaderboardEnabled = (): boolean => featureFlags.marketWideLeaderboard;
export const isEditSparksEnabled = (): boolean => featureFlags.editSparks;
export const isCommissionRulesEnabled = (): boolean => featureFlags.commissionRules;
export class FeatureDisabledError extends Error {
    constructor(featureName: string) {
        super(`Feature "${featureName}" is not enabled`);
        this.name = 'FeatureDisabledError';
    }
}
